import React, { useCallback, useState } from 'react';
import { Icon } from '../../../Icon';
import { ICalendarType } from '../../Calendar';
import { getAriaNavigationMonthBtn, getAriaOptionYearBtn, getAriaSelectYearBtn } from '../../helpers/ariaComposers';
import { calcYearAndMonth } from '../../helpers/dateFormatters';
import { generateRangeArray } from '../../helpers/others';
import { ICalendarPosition, ICalendarViewState, months } from '../CalendarView';
require("./CalendarViewNavigation.css");
var styles = {
  "Root": "CalendarViewNavigation-module-Root_16I",
  "NavigationButton": "CalendarViewNavigation-module-NavigationButton_1vo",
  "NavigationDisplayYear": "CalendarViewNavigation-module-NavigationDisplayYear_A10",
  "SelectYearOptionsContainer": "CalendarViewNavigation-module-SelectYearOptionsContainer_35t",
  "SelectYearOption": "CalendarViewNavigation-module-SelectYearOption_3ST"
};
export const CalendarViewNavigation = ({
  calendarType,
  calendarPosition,
  currentView,
  selectYearsFrom,
  selectYearsTill,
  onChangeViewYear,
  onDecrementMonthIndex,
  onIncrementMonthIndex
}) => {
  const [isSelectingYear, setIsSelectingYear] = useState(false);
  const toggleIsSelectingYear = useCallback(() => {
    setIsSelectingYear(prev => !prev);
  }, [setIsSelectingYear]);
  const changeViewYear = useCallback(e => {
    onChangeViewYear(parseInt(e.target.value));
    setIsSelectingYear(false);
  }, [onChangeViewYear, setIsSelectingYear]);
  const decrementMonthIndex = useCallback(() => {
    const updatedView = calcYearAndMonth({
      ...currentView,
      changeMonths: -1
    });
    onDecrementMonthIndex(updatedView);
  }, [onDecrementMonthIndex, currentView]);
  const incrementMonthIndex = useCallback(() => {
    const updatedView = calcYearAndMonth({
      ...currentView,
      changeMonths: 1
    });
    onIncrementMonthIndex(updatedView);
  }, [onIncrementMonthIndex, currentView]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Root
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": getAriaNavigationMonthBtn({
      calendarType,
      navBtnType: 'prev',
      ...{
        calendarPosition
      }
    }),
    className: styles.NavigationButton,
    onClick: decrementMonthIndex
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevronBack",
    size: "m"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles.NavigationDisplayMonth
  }, `${months[currentView.monthIndex]} `), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-block',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": getAriaSelectYearBtn({
      calendarType,
      ...{
        calendarPosition
      }
    }),
    value: currentView.year,
    className: styles.NavigationDisplayYear,
    onClick: toggleIsSelectingYear
  }, /*#__PURE__*/React.createElement("span", null, currentView.year)), /*#__PURE__*/React.createElement("div", {
    className: styles.SelectYearOptionsContainer,
    style: {
      display: `${!isSelectingYear ? 'none' : 'grid'}`
    }
  }, generateRangeArray(selectYearsFrom, selectYearsTill).map(year => /*#__PURE__*/React.createElement("button", {
    "aria-label": getAriaOptionYearBtn({
      calendarType,
      year,
      calendarPosition
    }),
    className: styles.SelectYearOption,
    key: year,
    value: year,
    onClick: changeViewYear
  }, year))))), /*#__PURE__*/React.createElement("button", {
    "aria-label": getAriaNavigationMonthBtn({
      calendarType,
      navBtnType: 'next',
      ...{
        calendarPosition
      }
    }),
    className: styles.NavigationButton,
    onClick: incrementMonthIndex
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevronRight",
    size: "m"
  })));
};